<template>
  <div
    :class="[
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: stateStoreInstance.open },
    ]"
    id="sidebar-area"
  >
    <div class="logo position-absolute start-0 end-0 top-0 bg-black">
      <router-link
        to="/"
        class="d-flex align-items-center text-white text-decoration-none"
      >
        <img
          :src="settingsStore.logo || require('../../assets/images/logo.png')"
          alt="logo-icon"
          style="width: 80%; max-height: 44px; object-fit: fill;"
        />
        <!-- <span class="fw-bold ms-10">growLogistics</span> -->
      </router-link>
      <div class="border-bottom"></div>
      <button
        class="sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0"
        @click="stateStoreInstance.onChange"
      >
        <i class="ph-duotone ph-caret-double-right"></i>
      </button>
    </div>
    <div class="sidebar-menu">
      <div v-if="!auth.permissionsLoaded && auth.permissions.length === 0" class="p-20 text-center text-white-50">
        <i class="ph-duotone ph-spinner ph-spin"></i>
      </div>
      <template v-else-if="auth.user && auth.user.role_id == 4">
        <ul
          class="sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion"
          id="sidebarNavAccordion"
        >
          <li class="sidebar-nav-item">
            <router-link to="/" class="sidebar-nav-link d-block">
              <i class="flaticon-more-1"></i>
              <span class="title">Dashboard</span>
            </router-link>
          </li>

          <li class="sidebar-nav-item" v-if="auth.can('PARCELS')">
            <router-link to="/colis-list" class="sidebar-nav-link d-block">
              <i class="flaticon-sterile-box"></i>
              <span class="title">Colis</span>
            </router-link>
          </li>

          <li class="sidebar-nav-item" v-if="auth.can('BDIS')">
            <router-link
              to="/distribution-notes"
              class="sidebar-nav-link d-block"
            >
              <i class="flaticon-cube-3d"></i>
              <span class="title">Bons distribution</span>
            </router-link>
          </li>

          <li class="sidebar-nav-item" v-if="auth.can('BP_L')">
            <router-link
              to="/payment-note-liste"
              class="sidebar-nav-link d-block"
            >
              <i class="flaticon-fast-delivery"></i>
              <span class="title">Factures livreurs</span>
            </router-link>
          </li>

          <!-- <li class="sidebar-nav-item" v-if="auth.can('CLAIM')">
            <router-link to="/claims-list" class="sidebar-nav-link d-block">
              <i class="flaticon-warning"></i>
              <span class="title">Réclamations</span>
            </router-link>
          </li> -->

          <li class="sidebar-nav-item">
            <router-link to="/profile" class="sidebar-nav-link d-block">
              <i class="flaticon-user"></i>
              <span class="title">Mon profile</span>
            </router-link>
          </li>
        </ul>
      </template>
      <template v-else-if="auth.user && auth.user.role_id == 3">
        <ul
          class="sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion"
          id="sidebarNavAccordion"
        >
          <li class="sidebar-nav-item">
            <router-link to="/" class="sidebar-nav-link d-block">
              <i class="flaticon-more-1"></i>
              <span class="title">Dashboard</span>
            </router-link>
          </li>

         

            <li class="sidebar-nav-item" v-if="auth.can('PARCELS')">
            <router-link to="/colis-list" class="sidebar-nav-link d-block">
              <i class="flaticon-sterile-box"></i>
              <span class="title">Colis</span>
            </router-link>
          </li>

           <li class="sidebar-nav-item" v-if="auth.can('BL')">
            <router-link to="/delivery-notes" class="sidebar-nav-link d-block">
              <i class="flaticon-document"></i>
              <span class="title">Bons de livraison</span>
            </router-link>
          </li>

           <li class="sidebar-nav-item" v-if="auth.can('RECEPTION')">
          <router-link to="/reception-notes" class="sidebar-nav-link d-block">
            <i class="flaticon-draft"></i>
            <span class="title">Réception Colis</span>
          </router-link>
        </li>


         <li class="sidebar-nav-item" v-if="auth.can('BE')">
          <router-link to="/sent-notes" class="sidebar-nav-link d-block">
            <i class="flaticon-telegram"></i>
            <span class="title">Bons d'envoi</span>
          </router-link>
        </li>


          <li class="sidebar-nav-item" v-if="auth.can('BDIS')">
            <router-link
              to="/distribution-notes"
              class="sidebar-nav-link d-block"
            >
              <i class="flaticon-cube-3d"></i>
              <span class="title">Bons distribution</span>
            </router-link>
          </li>

          <li
          v-if="auth.can('BP_L') || auth.can('BP_Z')"
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapsePayments"
            aria-expanded="false"
            aria-controls="sidebarCollapsePayments"
          >
            <i class="flaticon-fast-delivery"></i>
            <span class="title">Factures Livreurs</span>
          </a>
          <div
            id="sidebarCollapsePayments"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item" v-if="auth.can('BP_L')">
                  <router-link
                    to="/payment-note-liste"
                    class="sidebar-sub-menu-link"
                  >
                    Factures livreurs
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="auth.can('BP_Z')">
                  <router-link
                    to="/payment-zone-liste"
                    class="sidebar-sub-menu-link"
                  >
                    Factures Zones
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>

         <li class="sidebar-nav-item" v-if="auth.can('BR_Z')">
            <router-link to="/return-zone-liste" class="sidebar-nav-link d-block">
              <i class="flaticon-project"></i>
              <span class="title"> Retours zones</span>
            </router-link>
          </li>



          <li class="sidebar-nav-item" v-if="auth.can('CLAIM')">
            <router-link to="/claims-list" class="sidebar-nav-link d-block">
              <i class="flaticon-warning"></i>
              <span class="title">Réclamations</span>
            </router-link>
          </li>

          <li
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapseEleven"
            aria-expanded="false"
            aria-controls="sidebarCollapseEleven"
          >
            <i class="flaticon-user-3"></i>
            <span class="title">Utilisateurs</span>
          </a>
          <div
            id="sidebarCollapseEleven"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item" v-if="auth.can('USERS')">
                  <router-link to="/users-list" class="sidebar-sub-menu-link">
                    Liste des utilisateurs
                  </router-link>
                </li>
                <li
                  class="sidebar-sub-menu-item"
                  v-if="auth.can('NEW_LIVREUR')"
                >
                  <router-link
                    to="/new-driver-list"
                    class="sidebar-sub-menu-link"
                  >
                    Nouveaux livreurs
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>
        

          <li class="sidebar-nav-item">
            <router-link to="/profile" class="sidebar-nav-link d-block">
              <i class="flaticon-user"></i>
              <span class="title">Mon profile</span>
            </router-link>
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import stateStore from "../../utils/store";
import { useAuthStore } from "@/stores/auth";
import { useSettingsStore } from "@/stores/settings";

export default defineComponent({
  name: "MainSidebar",
  setup() {
    const stateStoreInstance = stateStore;
    const auth = useAuthStore();
    const settingsStore = useSettingsStore();

    onMounted(() => {
      settingsStore.fetchSettings();
    });

    return {
      stateStoreInstance,
      auth,
      settingsStore,
    };
  },
});
</script>